import script from "./ExceedingNumTip.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExceedingNumTip.vue?vue&type=script&setup=true&lang=ts"

import "./ExceedingNumTip.vue?vue&type=style&index=0&id=586be338&lang=scss"

const __exports__ = script;

export default __exports__